const emptyBpDetailsState = {
  selectedBp: {},
  accessVersion: 0,
  relationship: {
    owner: [],
    responsiblePersons: [],
    agent: [],
    occupant: []
  },
  localSearchFileResults: [],
  localSearchTruncated: false,
  isSearching: false,
  guruMessages: [],
  connectedUsers: [],
  userRelation: [],
  bulkShareStatus: {
    loading: false,
    error: null
  },
  externalSharedFiles: {
    loading: false,
    error: null,
    data: []
  },
  sharedExternals: [],
  sharedInternals: [],
  internalSharedUsers: {
    loading: false,
    error: null,
    data: []
  },
  bulkUnshareStatus: {
    loading: false,
    error: null
  },
  userFoundByEmail: null,
  bpFilesList: [],

  invitations: {
    loading: false,
    error: null,
    data: []
  },
}

export default emptyBpDetailsState
